import React, { Component } from "react";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import URL from 'url-parse';
import * as wActs from "../actions/website-actions";

class AgencyItem extends Component {

  decodeEntities(str) {
    return str.replace(/&#(\d+);/g, function(match, dec) {
      return String.fromCharCode(dec);
    });
  }

  setMarkup(agt) {
    let markup = "";
    if(agt.Text !== "" && typeof agt.Text !== "undefined") {
      markup = _.truncate(this.decodeEntities(agt.Text),{length: 200});
    }
    return {__html: markup};
  }

  getTranslation(key) {
    return this.props.Website.Translations[key];
  }
  getTranslationAndReplace(key, rKey, rVal) {
    let tRep = this.props.Website.Translations[key];
    return tRep.replace(rKey,rVal);

  }

  backLoadImage() {
    let img = new Image();
    img.onload = () => {
      try {
        this.myImg.src = this.myImg.getAttribute("real-img");
      } catch(ex) {}
    }
    try {
      img.src = this.myImg.getAttribute("real-img");
    } catch(ex1) {}
  }

  componentDidMount() {
    this.eCnt = 0;
    this.imgInt =
      setInterval(()=> {
        try {
          if(this.myImg.complete) {
            clearInterval(this.imgInt);
            this.backLoadImage();
          }
        } catch(ex) {
          this.eCnt++;
          if(this.eCnt>20) {
            clearInterval(this.imgInt);
          }
        }
      },100);
  }


  render() {
    let agt = this.props.Agent
    let url = new URL(agt.Url);
    let path = url.pathname;
    //console.log(agt);
    let cCity = "";





    return (


        <div className="escort-agency">

          {!wActs.isNullOrEmpty(agt.LogoUrl) &&
          <Link to={path} title={this.props.Website.Page.AltText.replace("{{Name}}",agt.Name)} onClick={(e) => {window.ScrollTop()}} className="image">
            <img src="/imgs/spacer-375x500.png" real-img={agt.LogoUrl.replace("preview", "source")}  ref = {(ref) => {this.myImg = ref}} alt={this.props.Website.Page.AltText.replace("{{Name}}",agt.Name)}/>
          </Link>}

          <div className="text-content">
            <h3 className="agency-title"><Link to={path} title="" onClick={(e) => {window.ScrollTop()}}>{agt.Name}</Link></h3>
            <div className="profiles-wrapper row small-gutter">
                {agt.Profiles.map((v,i) => {
                  if (i > 4) {
                    return;
                  }
                  let purl = new URL(v.Url);
                  let ppath = purl.pathname;
                  return (
                    <div key={"model-" + i} className="col_16">
                      {i<=3 &&
                        <Link key={"aimg-" + i} to={path} title={this.props.Website.Page.AltText.replace("{{Name}}",agt.Name) + i} onClick={(e) => { window.ScrollTop() }}><img src={v.ImageUrl} alt={this.props.Website.Page.AltText.replace("{{Name}}",agt.Name) + i}/></Link>
                      }
                      {i===4 && agt.Profiles.length> 5 &&
                        <Link className="more-profiles" key={"aimg-" + i} to={path} title={this.props.Website.Page.AltText.replace("{{Name}}",agt.Name) + i} onClick={(e) => { window.ScrollTop() }}><span>+{agt.ModelsCount - 5}</span><img src={v.ImageUrl} alt={this.props.Website.Page.AltText.replace("{{Name}}",agt.Name) + i}/></Link>
                      }
                      {i===4 && agt.Profiles.length<= 5 &&
                        <Link key={"aimg-" + i} to={path} title={this.props.Website.Page.AltText.replace("{{Name}}",agt.Name) + i} onClick={(e) => { window.ScrollTop() }}><img src={v.ImageUrl} alt={this.props.Website.Page.AltText.replace("{{Name}}",agt.Name) + i}/></Link>
                      }
                    </div>
                  );
                })}
            </div>
            <Link to={path} title="" className="read-more" onClick={(e) => {window.ScrollTop()}}>View More <img src="/imgs/white-right-arrow.svg" alt="More"/></Link>
          </div>
        </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    Website: state.Website
  };
}

export default connect(mapStateToProps)(AgencyItem);
